import { ModularityActionTypes, ModularityActionList } from '../actions/actions-modularity';

/* eslint-disable */
export interface State {
  configs: {};
  isLoading: boolean;
}

const initialState: State = {
  configs: {
    /**
     * need this field on initial state, because it used in getRegistrationInfoForLoyaltyEloqua selector,
     * and get error in start of app, if it absent
     */
    contact: {},
    analytics: {}
  },
  isLoading: false
};

/* eslint-disable */
export function reducer(state = initialState, action: ModularityActionList): State {
  switch (action.type) {
    case ModularityActionTypes.InitModularityConfig:
      return { ...state, isLoading: true };

    case ModularityActionTypes.SetModularityConfig:
      return { ...state, configs: action.payload, isLoading: false };

    case ModularityActionTypes.SetModularityConfigFromRegistration:
      return { ...state, configs: action.payload, isLoading: false };

    default:
      return state;
  }
}
